import axios from "axios";
import React, { useEffect, useState } from "react";

function FAQ() {
  const [currentFaq, setCurrentFaq] = useState(0);
  const [datas, setDatas] = useState([]);
  useEffect(() => {
    axios
      .get(
        "/office/staticpages/faq.json"
      )
      .then((response) => setDatas(response.data))
      .catch((error) => console.error("Error fetching the content:", error));
  }, []);
  return (
    <>
      <section className="content">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3
                  className="card-title text-color-1"
                  style={{ fontWeight: "200", fontSize: "22px" }}
                >
                  FAQ
                </h3>
              </div>
              <div className="card-body">
                <div class="container">
                  <div className="panel-group1">
                    {datas.map((item, index) => {
                      return item.content ? (
                        <div
                          key={item.title}
                          class="panel panel-default mb-4 border p-3"
                        >
                          <div class="panel-heading1">
                            <h4 class="panel-title1 mb-0">
                              <a
                                href="#"
                                class={`accordion-toggle ${currentFaq === index + 1 ? "" : "collapsed"
                                  }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCurrentFaq(
                                    currentFaq === index + 1 ? 0 : index + 1
                                  );
                                }}
                              >
                                {item.title}
                              </a>
                            </h4>
                          </div>
                          <div
                            class={`panel-collapse active collapse ${currentFaq === index + 1 ? "show" : ""
                              }`}
                          >
                            <div
                              class="panel-body"
                              style={{ whiteSpace: "pre-wrap" }}
                              dangerouslySetInnerHTML={{ __html: item.content }}
                            >

                            </div>
                          </div>
                        </div>
                      ) : <h4 className="my-2">{item.title}</h4>;
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FAQ;
